import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentPlannerProfileEndpoint } from '../constants/shipment-planner-profile-endpoint';
import { ShipmentPlannerProfileListStateModel } from './shipment-planner-profile-list.state';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { PlannerProfileListSearchCriteria } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileListService {
  constructor(private http: WrapperHttpService) {}

  getShipmentPlannerProfileList(
    searchCriteria: PlannerProfileListSearchCriteria,
  ): Observable<ShipmentPlannerProfileListStateModel> {
    const url =
      `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<ShipmentPlannerProfileListStateModel>(url);
  }
}
